<template>
    <layout-main :banner="banner" subtitle="新闻资讯" :isTrue="false" :isSubtext="true">
        <template v-slot:content>
            <h1 class="title news-title">{{ objInfo.title }}</h1>
            <div class="info">
                <h3 class="subTime">来源： {{objInfo.source}}</h3>
                <h3 class="subTime">作者： {{objInfo.author}}</h3>
                <h3 class="subTime">发布时间：{{objInfo.publishTime}}</h3>
            </div>
            <div class="text" v-html="objInfo.context"></div>
            <div class="pageText" v-if="pageList">
                <div class="previous" @click="getNextList(pageList.previous)">
                    <i class="el-icon-arrow-left"></i>
                    <span class="p-btn">上一篇</span>
                    <div class="p-title "> {{pageList.previous ?pageList.previous.title : '没有了'}}</div>
                </div>
                <div class="previous" @click="getNextList(pageList.next)">
                    <i class="el-icon-arrow-left"></i>
                    <span class="p-btn">下一篇</span>
                    <div class="p-title">{{pageList.next ? pageList.next.title : '没有了'}}</div>
                </div>
            </div>
        </template>
    </layout-main>
</template>
<script>
import layoutMain from '@/components/layout-main.vue'
import banner from '@/assets/news/banner.png'
import { getPvNumber,GetInfoPN } from '@/api/api'
export default {
    components: {
        layoutMain,
    },
    data () {
        return {
            banner: banner,
            objInfo: {},
            pageList: {},
        }
    },
    methods: {
        getNextList(val){
            if(val){
                sessionStorage.setItem('objInfo', JSON.stringify(val))
                this.objInfo = val;
                this.getPageList()
                this.$router.go(0);
            }
        },
        getPageList() {
            getPvNumber({id:this.objInfo.id}).then(res => {})
            GetInfoPN({id:this.objInfo.id}).then(res => {
                this.pageList = res.data
            })
           
        }
    },
    mounted() {
        if(this.$route.params.obj){
            sessionStorage.setItem('objInfo', JSON.stringify(this.$route.params.obj))
            this.objInfo = this.$route.params.obj
        }else{
            this.objInfo = JSON.parse(sessionStorage.getItem('objInfo'))
        }
       this.getPageList()
    }
}
</script>
<style lang="scss" scoped>
.pageText{
    width: 100%;
    .previous{
        padding: 10px;
        cursor: pointer;
        display: flex;
        align-items: center;
        .p-btn{
            margin: 0 10px;
        }
        .p-title{
            margin-left: 10px;
            color: #969595;
        }
    }
}
.title{
    margin-top: -40px;
    text-align: left;
    font-weight: 600;
    font-size: 35px;
}
.info{
    display: flex;
    
}
.subTime{
    text-align: left;
    margin-top: 10px;
    margin-left: 10px;
    color: #969595;
    &:first-child{
        margin-left: 0;
    }
}
.text{
    min-height: 230px;
    margin-top: 25px;
    /deep/ img{
        width: 100% ;
    }
}
</style>
